import { render, staticRenderFns } from "./BudgetDetailComponent.vue?vue&type=template&id=6bc15e92&scoped=true&"
import script from "./BudgetDetailComponent.vue?vue&type=script&lang=js&"
export * from "./BudgetDetailComponent.vue?vue&type=script&lang=js&"
import style0 from "./BudgetDetailComponent.vue?vue&type=style&index=0&id=6bc15e92&prod&lang=css&"
import style1 from "./BudgetDetailComponent.vue?vue&type=style&index=1&id=6bc15e92&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc15e92",
  null
  
)

export default component.exports